import styled from 'styled-components';

const ProgressHolderContainer = styled.div`
    margin-bottom: 40px;
    h4 {
        margin-bottom: 15px;
        font-weight: normal;
        text-transform: uppercase;
    }
    .prog {
        background-color: #dedadc;
        height: 30px;
        span {
            display: block;
            background-color: var(--main-color);
            height: 100%;
            position: relative;
            &::before {
                content: attr(data-progress);
                position: absolute;
                background-color: black;
                color: white;
                top: -40px;
                right: -18px;
                padding: 4px 0;
                width: 40px;
                text-align: center;
                border-radius: 4px;
            }
            &::after {
                content: '';
                position: absolute;
                border-style: solid;
                border-width: 8px;
                border-color: black transparent transparent;
                right: -8px;
                top: -15px;
            }
        }
    }
`;

export default ProgressHolderContainer;
